import { useContext } from "react";

import { AgenticAiContext } from "@lib/agenticAi";

export const useAgenticAiContext = () => {
  return useContext(AgenticAiContext);
};
